import styles from './MediaContentCard.module.css'
import classNames from 'classnames'
import type { MediaProps } from '../../atoms/Media/Media'
import { Media } from '../../atoms/Media/Media'

interface MediaContentCardProps {
  children: React.ReactNode
  media: MediaProps
  mediaPosition?: 'left' | 'right'
}

export const MediaContentCard = ({ media, children, mediaPosition = 'left' }: MediaContentCardProps) => {
  const mediaContentCardClasses = classNames(styles.MediaContentCard, {
    [styles[`MediaContentCard--image-${mediaPosition}`]]: mediaPosition,
  })

  return (
    <div className={mediaContentCardClasses}>
      <div className={styles.MediaContentCard__image}>
        <div className={styles[`MediaContentCard__image-container`]}>
          <Media src={media.src} config={{ ...media.config, objectFit: 'cover' }} />
        </div>
      </div>
      <div className={styles.MediaContentCard__content}>{children}</div>
    </div>
  )
}
